module.exports = __webpack_public_path__ + "img/business_03.e4dc672b.png";